<template>
    <div>
        <div class="portlet" id="users" v-if="users.length">
            <div class="portlet portlet-header-only light pb-1">
                <h2 v-text="Lang.get('messages.users')"></h2>
            </div>

            <div class="portlet portlet-table-only light p-0">
                <table class="table table-striped table-portlet">
                    <thead>
                    <tr>
                        <td>#</td>
                        <td v-text="Lang.get('messages.name')"></td>
                        <td>E-mail</td>
                        <td v-text="Lang.get('messages.lastActive')"></td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in users">
                        <td><code>{{ user.id }}</code></td>
                        <td>
                            <a :href="'/admin/users/' + user.id" v-text="user.name" :title="Lang.get('form.edit')"></a>
                        </td>
                        <td>{{ user.email }}</td>
                        <td v-text="user.last_login_at != undefined ? moment(user.last_login_at).format('D.M.YYYY, H:mm') : Lang.get('messages.none')"></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="portlet light bordered" id="create-user">
            <h2 v-text="Lang.get('messages.addNewInstitutionManager')"></h2>

            <create-and-assign-user-form @created="loadUsers" :institution="institution"></create-and-assign-user-form>
        </div>
    </div>
</template>

<script>
    import CreateAndAssignUserForm from './CreateAndAssignUserForm';

    export default {
        props: ['institution'],

        data() {
            return {
                users: this.institution.users,
                moment: moment,
            }
        },

        components: { CreateAndAssignUserForm },

        methods: {
            loadUsers() {
                axios.get('/admin/institutions/' + this.institution.id + '/users')
                    .then(response => this.users = response.data);
            }
        }
    }
</script>
